export default __webpack_public_path__ + "static/media/wake-surf-photo.689c522a.jpg";